<template>
  <van-tabs>
    <van-tab title="考勤打卡">
      <!-- 定位打卡专属页面结构 -->

      <div class="check-container">
        <div id="map-container" style="height: 350px"></div>
        <!-- 操作按钮 -->
        <div class="button-group">
          <van-button type="primary" style="padding: 5px 5px 5px 5px" @click="getlocation()">我的位置</van-button>
          <van-button
            type="primary" style="padding: 5px 5px 5px 5px"
            @click="handleCheck('IN')"
            :disabled="!canCheckIn"
            :class="{ 'disabled': !canCheckIn }"
          >{{'签入' }}</van-button>
          <van-button
            type="warning" style="padding: 5px 5px 5px 5px"
            @click="handleCheck('OUT')"
            :disabled="!canCheckOut"
            :class="{ 'disabled': !canCheckOut }"
          >{{'签出' }}</van-button>
        </div>
      </div>

    </van-tab>
    <van-tab title="出差打卡">
      <aside class="approval-item" v-for="(item,i) in approvalList" :key="item.Approval_Sub_GUID">
        <input
          type="hidden"
          :name="'Approval_Sub_GUID_' + item.Approval_Sub_GUID"
          :id="'Approval_Sub_GUID_' + item.Approval_Sub_GUID"
          v-model="item.Approval_Sub_GUID"
        >
        <input
          type="hidden"
          :name="'Longitude_' + item.Approval_Sub_GUID"
          :id="'Longitude_' + item.Approval_Sub_GUID"
          v-model="item.Longitude"
        >
        <input
          type="hidden"
          :name="'Latitude_' + item.Approval_Sub_GUID"
          :id="'Latitude_' + item.Approval_Sub_GUID"
          v-model="item.Latitude"
        >
        <div class="BeginDate">日期：{{item.BeginDate}}</div>
        <div class="Destination">地址:{{item.Destination}}</div>
        <!-- 🚀 修改按钮逻辑 -->
        <!--<div class="butt">
          <van-button type="primary" style="padding: 5px 5px 5px 5px"
            @click="handleBusinessCheck(item, 'IN')"
          >签入</van-button>

          <van-button type="warning" style="padding: 5px 5px 5px 5px;margin-left: 10px"
            @click="handleBusinessCheck(item, 'OUT')"
          >签出</van-button>
        </div>-->
        <div class="butt">
          <!-- 签入按钮 -->
          <van-button
            type="primary"
            :disabled="Number(item.CheckType) === 0"
          :class="{ 'disabled-btn': Number(item.CheckType) === 0 }"
          @click="handleBusinessCheck(item, 'IN')"
          >签入</van-button>

          <!-- 签出按钮 -->
          <van-button
            type="warning"
            :disabled="Number(item.CheckType) === 1"
          :class="{ 'disabled-btn': Number(item.CheckType) === 1 }"
          style="margin-left: 10px"
          @click="handleBusinessCheck(item, 'OUT')"
          >签出</van-button>
        </div>
      </aside>
    </van-tab>
  </van-tabs>
</template>

<script>
  import AMapLoader from '@amap/amap-jsapi-loader'
  //import wx from 'weixin-js-sdk'

  import {ValidateLocationApi,getLastOfficesApi,CoordConvertRequestApi,GetNetBooktokenApi,GetApplyFormFLReadyApi,GetApplyLocationsLastRecordApi,ValidateApplyLocationsApi} from '@/api/common'
  export default {
    data() {
      return {
        // ✨ 新增状态管理字段
        checkingItemId: null,    // 当前操作中的条目ID
        lastRecord: null,
        map: null,
        position: null,
        errorMsg:'',
        isWxReady:true,
        approvalList: [],
        config: {
          key: '749238a22308fd82317ce29340a824bc',
          securityJsCode: '40e8135d9f45d89f3cb482edd41fbde0',
          version: '2.0', // API版本
          plugins: ['AMap.Geolocation', 'AMap.AutoComplete']
        }
      }
    },
    mounted() {
      this.initMap();//初始化地图
      this.init();//初始化微信获取token
      this.getLastOffices();
      this.getApprovalList();
    },
    computed: {
// 所有计算属性平级声明
      canCheckIn() {
        debugger
        return !this.lastRecord ||
          (this.lastRecord && this.lastRecord.CheckType === 1 )
      },
      canCheckOut() {
       debugger
        return this.lastRecord && this.lastRecord.CheckType === 0
      },
    },
    methods: {
      async loadWxSDK() {
        return new Promise((resolve) => {
          if (typeof wx !== 'undefined') {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
          script.onload = resolve;
          document.head.appendChild(script);
        });
      },
      // 修改后的 init 方法
      async init() {
        await this.loadWxSDK();
        try {
          const currentUrl = window.location.href.split('#')[0];
          let params = {
            URL: currentUrl
          };
          const response = await GetNetBooktokenApi(params);
          if (!response) throw new Error("签名参数获取失败");

          // 记录签名参数用于调试
          console.log("微信配置参数:", {
            appId: 'wx6ec26bec46f7099d',
            timestamp: response.result.timestamp,
            nonceStr: response.result.noncestr,
            signature: response.result.signature
          });

          // 强制清除旧配置（针对微信缓存问题）
          wx.config({
            debug: false,
            appId: 'wx6ec26bec46f7099d',
            timestamp: response.result.timestamp.toString(),
            nonceStr: response.result.noncestr,
            signature: response.result.signature,
            jsApiList: [
              'getLocation'
            ],// 添加防缓存参数
            _t: Date.now()

          });

          // 使用 Promise 包装 ready/error 事件
          await new Promise((resolve, reject) => {
            wx.ready(() => {
              console.log('微信 SDK 初始化完成，注入的 API:', Object.keys(wx).filter(k => typeof wx[k] === 'function'));
              this.isWxReady = true;
              resolve();
            });

            wx.error(err => {
              console.error('微信 SDK 初始化失败:', err);
              reject(err);
            });
          });

        } catch (error) {
          console.error("初始化失败:", error);
          this.$toast.fail("微信服务初始化失败: " + error.message);
          // 特殊处理签名错误
          if (error.message.includes("signature")) {
            this.$toast.fail("请检查后端签名生成逻辑！");
          }
        }
      },
      // 修改后的 getlocation 方法
      async getlocation() {
        try {
          if (!this.isWxReady) {
            throw new Error("微信 SDK 未初始化完成");
          }

          // 直接调用检查逻辑（不再嵌套 wx.ready）
          await this.checklocation();
        } catch (error) {
          //console.error('定位流程失败:', error);
          // ...
          fail: (err) => {
            console.error('定位失败完整错误对象:', JSON.stringify(err, null, 2));
          }
        }
      },

      // 错误处理函数示例
      handleWeChatError(errorCode) {
    switch (errorCode) {
      case 'invalid signature':
        console.error('签名错误：请检查后端生成的签名参数（URL、nonceStr、timestamp）是否正确');
        // 可尝试重新获取签名并初始化
        break;
      case 'invalid url':
        console.error('URL 未备案：请登录微信公众号后台配置 JS接口安全域名');
        break;
      case 'invalid appid':
        console.error('AppID 错误：检查公众号 AppID 或测试号配置');
        break;
      case 'permission denied':
        console.error('接口未授权：检查 jsApiList 中的接口名称是否拼写正确，并在公众号后台授权');
        break;
      default:
        console.error('未知错误：请参考微信官方文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#67');
    }
  },
      // 微信定位主方法
      // 修改后的方法（使用 async/await）

      async checklocation() {
        try {
          console.log('检查权限前的 wx 对象状态:', wx);
          await this.getWeChatLocation();
          /*const res = await new Promise((resolve, reject) => {
            wx.getSetting({
              success: (res) => {
                console.log('getSetting 返回结果:', JSON.stringify(res, null, 2));
                resolve(res);
              },
              fail: (err) => {
                console.error('getSetting 失败:', err);
                reject(err);
              }
            });
          });

          // 处理权限状态
          const hasLocationPermission = res.authSetting && res.authSetting['scope.userLocation'] === true;
          console.log('当前位置权限状态:', hasLocationPermission);

          if (hasLocationPermission) {
            await this.getWeChatLocation();
          } else {
            console.log('尝试请求位置权限...');
            await this.handleAuth();
          }*/
        } catch (error) {
          console.error('checklocation 流程异常:', error);
          this.$toast.fail(`定位流程出错: ${error.errMsg || error.message}`);
        }
      },

      async handleAuth() {
        try {
          await new Promise((resolve, reject) => {
            wx.authorize({
              scope: 'scope.userLocation',
              success: resolve,
              fail: reject
            });
          });
          //await this.getWeChatLocation();
        } catch (error) {
          const errorMsg =error && error.errMsg || '未知错误';
          if (errMsg.includes('auth deny')) {
            // 用户拒绝授权，显示引导弹窗
            this.$dialog.confirm({
              title: '权限提示',
              message: '需要位置权限才能打卡，是否前往设置开启？',
            }).then(() => {
              wx.openSetting(); // 跳转到设置页
            }).catch(() => {
              this.$toast('已取消');
            });
          } else {
            //this.showManualAuthGuide();
            this.$toast.fail(`授权失败: ${error.errMsg}`);
          }
        }
      },

      showManualAuthGuide() {

        const userWantsToConfirm = confirm('权限请求需要位置权限，请到设置页面开启？');
        // 根据用户选择进行操作
        if (userWantsToConfirm) {
          wx.openSetting({
            success: (res) => {
              if (res.authSetting['scope.userLocation']) {
                this.getWeChatLocation();
              }
            }
          });
        }
      },

      getWeChatLocation() {

        let that = this;
        wx.getLocation({
          type: 'gcj02', // 直接获取高德支持的GCJ02坐标系
          success: (res) => {
            this.position = {
              lng: res.longitude,
              lat: res.latitude
            }

            //alert(this.position.lng);
            //alert(this.position.lat);
            //接上高德地图定位,在地图上标记出来
            this.handlePositionSuccess(this.position.lng,this.position.lat);
          },
          fail: (err) => {
            this.$toast.fail(`定位失败: ${err.errMsg}`);
          }
        });
      },
      // 坐标系转换方法（调用后端）
      convertCoord(lng,lat) {
        let params = {
          lng: lng,
          lat: lat,
          from: 'wgs84'
        };
        let response = CoordConvertRequestApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let lations=(response.msg).splice(',');
            this.position={
              lat:lations[0],
              lng:lations[1],
            }
          }
          this.$toast.fail(response.msg);

        }
      },

      truncatedValue(Value) {
        const parts = Value.split(".");
        if (parts.length === 1) {
          return parts[0] + ".000000";
        } else {
          const decimal = parts[1].padEnd(6, "0").slice(0, 6);
          return parts[0] + "." + decimal;
        }
      },

      // 微信错误码解析
      parseWechatError(err) {
        const errMap = {
          1: '用户拒绝授权',
          2: '网络不可用',
          3: '定位超时',
          4: '定位失败'
        }
        return errMap[err.errCode] || '定位服务异常'
      },

      async initMap() {
        try {
          // 加载JS API
          const AMap = await AMapLoader.load(this.config)

          // 初始化地图
          this.map = new AMap.Map('map-container', {
            zoom: 16,  // 初始缩放级别
            resizeEnable: true
          })
          //this.handlePositionSuccess('120.745253','31.270157');//测试
          // 添加定位控件
          //this.addGeolocationControl(AMap)

          // 自动获取当前定位
          //this.getCurrentPosition(AMap)

        } catch (error) {
          console.error('地图加载失败:', error)
          this.$message.error('地图服务初始化失败')
        }
      },
      // 添加定位控件
      /*addGeolocationControl(AMap) {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 高精度定位
          timeout: 10000, // 超时时间10秒
          buttonPosition: 'RB' // 控件显示在右下角
        })
        this.map.addControl(geolocation)
      },

      // 获取当前位置
      getCurrentPosition(AMap) {
        const geolocation = new AMap.Geolocation()
        geolocation.getCurrentPosition((status, result) => {
          if (status === 'complete') {
            this.handlePositionSuccess(result)
          } else {
            this.handlePositionError(result)
          }
        })
      },*/

      // 定位成功处理
      handlePositionSuccess(lng,lat) {
        this.position = {
          lng: lng,
          lat: lat
        }
        // 地图中心点定位到当前位置
        this.map.setCenter([lng,lat])
        // 添加标记
        this.addMarker(this.position)
      },

      // 定位失败处理
      handlePositionError(err) {
        let msg = '定位失败'
        if (err.info === 'PERMISSION_DENIED') {
          msg = '用户拒绝了定位权限'
        } else if (err.info === 'TIMEOUT') {
          msg = '定位超时，请重试'
        }
        this.$toast.fail(msg);
      },

      // 添加地图标记
      addMarker(position) {
        new AMap.Marker({
          position: [position.lng, position.lat],
          title: '当前位置',
          map: this.map
        })
      },

    beforeDestroy() {
      // 销毁地图实例
      if (this.map) {
        this.map.destroy()
      }
    },
      //获取最后一次打卡记录
      async getLastOffices() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo")
          let params = {
            C_GUID:companyInfo.companyId,
            userId: userInfo.U_GUID
          };
          let response =await getLastOfficesApi(params);
          if (response.success) {
            if (response.code === "0000") {
              if (response.result!=[]&&response.result[0].Id !== undefined && response.result[0].Id !== null && response.result[0].Id !== "") {
                this.lastRecord=response.result[0];
              }
              else{
                this.lastRecord="";
              }
            }
          }

      },
      //考勤打卡
      async handleCheck(type) {
// 获取定位
       //let atq= this.position;
       if(this.position==null){
         this.$toast.success("请先获取我的位置");
         return;
       }
        let CheckType=0
        if(type=="IN"){
          CheckType=0
        }else if(type=="OUT"){
          CheckType=1
        }
        let companyInfo = this.getCookie("CompanyInfo");
        let userInfo = this.getCookie("UserInfo");
        let params = {
          cGuid:companyInfo.companyId,
          UserId:userInfo.U_GUID,
          Latitude:this.position.lat,
          Longitude:this.position.lng,
          CheckType:CheckType
        };
        let response = await ValidateLocationApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.$toast.success(response.msg);
            this.$router.push({path: '/home'});
            return;
          }
          this.$toast.fail(response.msg);
          // return;
        }
      },

      getStatusMessage(status, type) {
        let actions = { IN: '签到', OUT: '签退' };
        let messages = {
          normal: `正常${actions[type]}（默认办公地点）`,
          abnormal: `异常${actions[type]}（非默认地点）`,
          error: '未获取到位置信息，请重新操作'
        };
        return messages[status] || '未知状态';
      },

      //获取待审批列表
      async getApprovalList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          C_GUID: companyInfo.companyId,
          userId: userInfo.U_GUID,
        };
        let response = await GetApplyFormFLReadyApi(params);
        if (response.success) {
          this.approvalList = response.result;
        }

      },
      // 🚀 修改后的出差打卡处理方法
      async handleBusinessCheck(item, type) {
        try {
          // 防止重复提交
          //if (this.checkingItemId === item.Approval_Sub_GUID) return
          //this.checkingItemId = item.Approval_Sub_GUID

          // 获取当前位置
          await this.getWeChatLocation()
          //this.position = {
            //lng: 120.745663,
            //lat: 31.371275
         // }
          if (!this.position) {
            this.$toast.fail('获取位置失败')
            return
          }

          // ✨ 更新当前条目的坐
          //item.Longitude = position.lng
          //item.Latitude = position.lat

          // ✨ 执行打卡逻辑
          const success = await this.submitBusinessCheck(item, type)
          if (success) {
            this.$toast.success(type === 'IN' ? '签入成功' : '签出成功')
            this.$router.push({path: '/home'});
            return;
          }
        } catch (error) {
          console.error('打卡失败:', error)
          this.$toast.fail(error.message || '打卡失败')
        } finally {
          this.checkingItemId = null
        }
      },

      // ✨ 新增通用位置获取方法
      async getCurrentPosition() {
        try {
          if (this.isWxReady) {
            // 微信定位
            const res = await new Promise((resolve, reject) => {
              wx.getLocation({
                type: 'gcj02',
                success: resolve,
                fail: reject
              })
            })
            return { lng: res.longitude, lat: res.latitude }
          }

          // 浏览器原生定位
          /*const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              enableHighAccuracy: true,
              timeout: 5000
            })
          })
          return {
            lng: position.coords.longitude,
            lat: position.coords.latitude
          }*/
        } catch (error) {
          console.error('定位失败:', error)
          this.$toast.fail('获取位置信息失败')
          return null
        }
      },

      // ✨ 新增提交方法
      async submitBusinessCheck(item, type) {
        let companyInfo = this.getCookie("CompanyInfo");
        let userInfo = this.getCookie("UserInfo");
        const params = {
          cGuid: companyInfo.companyId,
          userId: userInfo.U_GUID,
          Approval_Sub_GUID: item.Approval_Sub_GUID,
          Latitude:this.position.lat,
          Longitude:this.position.lng,
          CheckType: type === 'IN' ? 0 : 1,
          APLatitude:item.Latitude,
          APLongitude:item.Longitude,
          Destination:item.Destination
        }

        const response = await ValidateApplyLocationsApi(params)
        if (response.code === '0000') {
          return true
        }
        throw new Error(response.msg || '打卡失败')
      },


    }

  }
</script>

<style scoped>
  .check-container {
    height: 100vh;
    overflow-y: auto;
    padding: 20px;
  }
  .button-group button {
    margin: 10px;
    padding: 15px 30px;
  }

  .status-box {
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .success { background: #e8f5e9; color: #2e7d32; }
  .warning { background: #fff3e0; color: #ef6c00; }
  .error { background: #ffebee; color: #c62828; }

  .status-box .emoji {
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
  .position-info {
    padding: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0,0,0,.1);
    margin-top: 20px;
  }

  .approval-item {
    height: 100vh; /* 总高度 */
    overflow-y: auto;
    background: white;
    margin: 1rem;
    padding: 1rem;
  }
  .BeginDate {
    color: #9c9c9c;
    font-size: 1.6rem;
  }

  .Destination {
    color: #333333;
    margin-top: 1rem;
    font-size: 1.6rem;
  }
  /* ✨ 新增状态样式 */
  .check-status {
    color: #666;
    font-size: 14px;
    margin-bottom: 8px;
  }
  /* 增强禁用状态的视觉提示 */
  .disabled-btn {
    opacity: 0.6;
    cursor: not-allowed;
  }
</style>
